export default __webpack_public_path__ + "static/media/art2.c96d8c81.png";